import React from 'react';
import { ModelFactory, ModelMapEditor } from '@leverege/ui-plugin';
import { List, Text, Checkbox } from '@leverege/ui-elements';
import Model from "../renderers/GeoPointModel.js";
import S from './LayerRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LayerRenderer(props) {
  const {
    item,
    onEvent,
    onParentChange,
    ...rest
  } = props;
  const name = item.name || item.layerName;
  const model = ModelFactory.get(item);
  const onChange = e => {
    const nModel = Model[e.data](item, e.value);
    onEvent({
      type: ModelMapEditor.EVT_CHILD_CHANGE,
      value: nModel,
      data: item
    });
  };
  return /*#__PURE__*/_jsxs(List.Item, {
    item: item,
    ...rest,
    contentClassName: S.renderer,
    children: [model.setVisible && /*#__PURE__*/_jsx(Checkbox, {
      value: Model.getVisible(item) !== false,
      eventData: "setVisible",
      onChange: onChange
    }), /*#__PURE__*/_jsx(Text, {
      variant: "listItemSubtitle",
      children: name
    })]
  });
}